import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Priya Sharma",
    role: "Homeowner, Sector 54",
    text: "Tank Buddy did an exceptional job cleaning our overhead tank. The team was punctual, professional, and left everything spotless. Highly recommended for anyone in Gurugram!",
    rating: 5,
  },
  {
    name: "Rajesh Mehta",
    role: "RWA President, DLF Phase 3",
    text: "We've been using Tank Buddy for our entire society of 200 flats. Their commercial cleaning service is thorough, and they always complete the job on the same day. Best service in Gurugram.",
    rating: 5,
  },
  {
    name: "Anita Kapoor",
    role: "Hotel Manager, Golf Course Road",
    text: "As a hotel, hygiene is our top priority. Tank Buddy's certified technicians and eco-friendly process give us complete peace of mind. They handle our quarterly cleaning flawlessly.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <p className="text-sky font-medium text-sm uppercase tracking-[0.2em] mb-3">
            Testimonials
          </p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight text-navy">
            What Our Customers Say
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              className="bg-surface border border-slate-200 rounded-xl p-8 hover:shadow-lg hover:border-sky/50 transition-all duration-300"
            >
              <Quote className="w-8 h-8 text-sky/30 mb-4" />
              <p className="text-navy text-sm leading-relaxed mb-6">
                "{t.text}"
              </p>
              <div className="flex items-center gap-1 mb-4">
                {[...Array(t.rating)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <div>
                <p className="font-heading font-semibold text-navy text-sm">{t.name}</p>
                <p className="text-slate-500 text-xs">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
